import { PropsWithChildren, useContext } from "react";

import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import LoadingScreen from "~/modules/app/screens/LoadingScreen";

import ClientContext from "../../context/ClientContext";

export default function RequiredClient({ children }: PropsWithChildren<unknown>) {
    const { client, loading, error } = useContext(ClientContext);

    if (error) {
        return <ErrorScreen error={error} />;
    }
    if (loading) {
        return <LoadingScreen />;
    }
    if (client) {
        return children;
    }
}
